// removed by extract-text-webpack-plugin
module.exports = {"robot":"styles-module__robot___1_7eb","webvr":"styles-module__webvr___1s1fz","vr-supported":"styles-module__vr-supported___21x0G"};


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/components/Robot/styles.module.css
// module id = 135
// module chunks = 0